import {
  CreateAgencyUserParam,
  GetAgencyUserByIdUsecase,
  GetAgencyUsersByAgencyParam,
  UpdateAgencyUserParam,
} from '@resident-select/domain/agency-user';
import { createAction, props } from '@ngrx/store';
import { SciGuaduaTransaction } from '@scifamek/guadua';

export const CreateAgencyUserCommand = createAction(
  'CreateAgencyUserCommand',
  props<SciGuaduaTransaction<CreateAgencyUserParam>>(),
);
export const UpdateAgencyUserCommand = createAction(
  'UpdateAgencyUserCommand',
  props<SciGuaduaTransaction<UpdateAgencyUserParam>>(),
);

export const GetAgencyUsersByAgencyCommand = createAction(
  'GetAgencyUsersByAgencyCommand',
  props<GetAgencyUsersByAgencyParam>(),
);
